import axios from 'axios';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const projectId = localStorage.getItem('currentProjectId');
  if (projectId) config.headers['X-Project-Id'] = projectId;
  return config;
});

const engagementService = {
  /** Drafts awaiting human approval. */
  async getPending({ limit = 50, skip = 0 } = {}) {
    const res = await api.get('/engagements/pending', { params: { limit, skip } });
    return res.data.data;
  },

  /** Approve drafts so the sequencer sends them. */
  async approve(ids) {
    const res = await api.post('/engagements/approve', { ids });
    return res.data.data;
  },

  /** Reject drafts so they are never sent. */
  async reject(ids, reason = 'rejected_by_user') {
    const res = await api.post('/engagements/reject', { ids, reason });
    return res.data.data;
  },

  /** Edit a draft before approving it. */
  async updateDraft(id, { messageSubject, initialMessage }) {
    const res = await api.patch(`/engagements/${id}`, { messageSubject, initialMessage });
    return res.data.data;
  },

  /** Queue counts, for badges. */
  async getStats() {
    const res = await api.get('/engagements/stats');
    return res.data.data;
  },
};

export default engagementService;
